<template>
  <div>
    <a :href="url" class="grid" @click.prevent="openModal">
      <div class="col-start-1 row-start-1">
        <MediaImage v-if="'image' in preview" v-bind="preview" />
        <MediaVideo v-else-if="'fileMobile' in preview" v-bind="preview" />
      </div>

      <div class="col-start-1 row-start-1 flex items-center justify-center">
        <div class="size-14 rounded-full bg-black/50">
          <SpriteSymbol name="play" class="size-full text-white" />
        </div>
      </div>
      <span class="sr-only">{{
        $texts('videoModal')
      }}</span>
    </a>
    <PageModal :modal-id class="modal-remote-video">
      <LazyMediaRemoteVideo v-bind="remoteVideo" />
    </PageModal>
  </div>
</template>

<script setup lang="ts">
import type {
  MediaCantoFragment,
  MediaImageFragment,
  MediaRemoteVideoFragment,
  MediaVideoFragment,
} from '#graphql-operations'

const props = defineProps<{
  id: string
  remoteVideo: MediaRemoteVideoFragment
  preview: MediaImageFragment | MediaCantoFragment | MediaVideoFragment | object
}>()

const { $texts } = useEasyTexts()

const url = computed(() => props.remoteVideo.url)

const { openModal, modalId } = useModal(props.id)
</script>

<style lang="postcss">
.modal-remote-video {
  .modal-container {
    width: 90vw;
  }
}

.modal-video {
  @apply relative;
}

.modal-video-preview {
  .video-play-button {
    @apply pointer-events-none;

    .icon {
      @apply relative left-0 top-[2px];
    }
  }
  &:hover {
    video,
    img {
      transform: scale(1.04);
    }
    .video-play-button .button {
      background: rgba($black, 0.9);
    }
  }
  video,
  img,
  .video-play-button .button {
    transition: 0.5s;
  }
  .image,
  picture {
    @apply overflow-hidden;
  }
}
</style>
